var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4",
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c(
        "validation-observer",
        { ref: "trainingDetailsForm", attrs: { novalidate: "", tag: "form" } },
        [
          _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c("section-title", {
                attrs: { "has-line": true, title: "Información General" }
              }),
              _c("div", { staticClass: "row ml-1" }, [
                _c(
                  "div",
                  { staticClass: "col-md-2 mb-3" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                staticClass: "w-100",
                                attrs: {
                                  "class-container": "",
                                  "custom-error-msg": "Fecha requerida.",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  label: "Fecha:",
                                  "max-date": new Date(),
                                  placeholder: "DD/MM/YYYY"
                                },
                                on: { input: _vm.onDateChange },
                                model: {
                                  value: _vm.model.date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "date", $$v)
                                  },
                                  expression: "model.date"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                attrs: {
                                  "custom-error-msg":
                                    "Favor seleccionar actividad.",
                                  disabled: !_vm.isAdding,
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Actividad:",
                                  options: _vm.activities,
                                  placeholder: "Seleccione"
                                },
                                on: { input: _vm.onActivityChange },
                                model: {
                                  value: _vm.model.selectedActivity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "selectedActivity", $$v)
                                  },
                                  expression: "model.selectedActivity"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm.showMunicipality
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      staticClass: "w-100",
                                      attrs: {
                                        "custom-error-msg":
                                          "Favor seleccionar municipio.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Municipio:",
                                        options: _vm.municipalities,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.model.selectedMunicipality,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "selectedMunicipality",
                                            $$v
                                          )
                                        },
                                        expression: "model.selectedMunicipality"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3087046583
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showPlace
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Favor escribir un lugar.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        label: "Lugar:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.place,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "place", $$v)
                                        },
                                        expression: "model.place"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2458305800
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showHour
                  ? _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-time-picker", {
                                      staticClass:
                                        "custom-datetime-picker-container",
                                      attrs: {
                                        "class-container": "",
                                        "custom-error-msg": "Hora requerida.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        "is-menu-right": false,
                                        label: "Hora Comienzo:"
                                      },
                                      model: {
                                        value: _vm.model.startHour,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "startHour", $$v)
                                        },
                                        expression: "model.startHour"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2676185944
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showDuration
                  ? _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      staticClass: "w-100",
                                      attrs: {
                                        "custom-error-msg":
                                          "Favor seleccionar duración.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Duración:",
                                        options: _vm.durations,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.model.selectedDuration,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "selectedDuration",
                                            $$v
                                          )
                                        },
                                        expression: "model.selectedDuration"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1370493890
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showSpecialist
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      staticClass: "w-100",
                                      attrs: {
                                        "custom-error-msg":
                                          "Favor seleccionar especialista.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Especialista:",
                                        options: _vm.specialists,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.model.selectedSpecialist,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "selectedSpecialist",
                                            $$v
                                          )
                                        },
                                        expression: "model.selectedSpecialist"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1748161826
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showParticipants
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "font-14 font-weight-normal mt-2 mb-0"
                          },
                          [_vm._v(" Participantes: ")]
                        ),
                        _vm._l(_vm.participants, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: `participant-chk-${index}`,
                              staticClass: "d-flex flex-wrap"
                            },
                            [
                              _c("checkbox", {
                                attrs: {
                                  disabled: _vm.isReadOnly,
                                  text: item.name
                                },
                                model: {
                                  value: item.selected,
                                  callback: function($$v) {
                                    _vm.$set(item, "selected", $$v)
                                  },
                                  expression: "item.selected"
                                }
                              }),
                              _c("validation-provider", {
                                attrs: {
                                  rules: !_vm.participants.some(p => p.selected)
                                    ? "required"
                                    : ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          errors[0] &&
                                          index == _vm.participants.length - 1
                                            ? _c("error", {
                                                attrs: {
                                                  message:
                                                    "Favor seleccionar al menos un participante.",
                                                  variant: "no-border"
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.showCost
                  ? _c(
                      "div",
                      { staticClass: "col-md-2 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: "costo",
                            rules: "required|min_value:1"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      staticClass: "custom-input__extended",
                                      attrs: {
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        label: "Costo:",
                                        max: 999999,
                                        min: 1,
                                        placeholder: "Escribir Costo",
                                        "prepend-icon": "fa fa-",
                                        "prepend-icon-text": "$",
                                        type: "number"
                                      },
                                      on: {
                                        keypress: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                        }
                                      },
                                      model: {
                                        value: _vm.model.cost,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "cost", $$v)
                                        },
                                        expression: "model.cost"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2189009270
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showComment
                  ? _c(
                      "div",
                      { staticClass: "col-12 mt-2" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        id: "comment",
                                        "custom-error-msg":
                                          "Favor escribir un comentario.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        label: "Comentario:",
                                        maxlength: 500,
                                        name: "comment",
                                        rows: 3,
                                        "show-char-count": true
                                      },
                                      model: {
                                        value: _vm.model.comment,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "comment", $$v)
                                        },
                                        expression: "model.comment"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2984613927
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm.showStudentSearch && !_vm.isReadOnly
            ? _c("div", { staticClass: "mt-3" }, [
                _c("div", { staticClass: "p-3 ml-3 rounded bg-secondary-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-5 border-right" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row align-items-center" },
                        [
                          _c("em", {
                            staticClass:
                              "fas fa-user-alt rounded-circle shadow p-2 color-primary-2 mr-2"
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-bold"
                            },
                            [_vm._v(" Búsqueda de Estudiante ")]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-4 ml-4" },
                        [
                          _c(
                            "validation-observer",
                            {
                              ref: "studentSearch",
                              attrs: { novalidate: "", tag: "form" }
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: _vm.selectedStudent ? "" : "required"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-input", {
                                            staticClass:
                                              "custom-input__extended",
                                            attrs: {
                                              "custom-error-msg":
                                                "Campo requerido - Debe buscar y seleccionar un estudiante.",
                                              error: errors[0],
                                              placeholder:
                                                "Escribir Número de SIE",
                                              "prepend-icon": "fa fa-search",
                                              "prepend-icon-click":
                                                _vm.onSearchStudentHandler,
                                              "prepend-icon-left": false,
                                              "prepend-icon-text": "Buscar",
                                              "prepend-icon-type": "success",
                                              type: "text"
                                            },
                                            on: {
                                              keypress: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                              }
                                            },
                                            model: {
                                              value: _vm.searchStudentSie,
                                              callback: function($$v) {
                                                _vm.searchStudentSie = $$v
                                              },
                                              expression: "searchStudentSie"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  331964441
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm.student.studentId
                      ? _c("div", { staticClass: "col-md-4 pl-5" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-secondary-6 font-weight-bold font-16"
                            },
                            [_vm._v(" Resultado ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column mt-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "color-secondary-6 mr-2" },
                                    [_vm._v("Nombre:")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.student.fullName || "-") +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-secondary-6 font-14 font-weight-normal mr-2"
                                    },
                                    [_vm._v(" Edad: ")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-normal"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.student.age || "-") +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-secondary-6 font-14 font-weight-normal mr-2"
                                    },
                                    [_vm._v(" SIE: ")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-normal"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.student.studentId || "-") +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-secondary-6 font-14 font-weight-normal mr-2"
                                    },
                                    [_vm._v(" Registro: ")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-normal"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.student.regNumber || "-") +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm.student.studentId
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-md-3 d-flex justify-content-end align-items-center"
                          },
                          [
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-check",
                                  variant: "outline-success"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onStudentSelection(_vm.student)
                                  }
                                }
                              },
                              [_vm._v(" Seleccionar ")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "mt-1" }, [
            _c(
              "div",
              { staticClass: "ml-3" },
              [
                _c(
                  "validation-observer",
                  {
                    ref: "selectedstudent",
                    attrs: { novalidate: "", tag: "form" }
                  },
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules:
                          _vm.searchStudentSie != null &&
                          _vm.student.studentSie == null &&
                          _vm.selectedStudent == null
                            ? "required"
                            : ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              errors[0]
                                ? _c("error", {
                                    attrs: {
                                      message:
                                        "Debe buscar y seleccionar un estudiante.",
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm.selectedStudent != null
            ? _c(
                "custom-callout",
                {
                  staticClass: "ml-3 mt-1 custom-callout",
                  attrs: { "has-toggle": false }
                },
                [
                  _c(
                    "div",
                    { staticClass: "ml-4 bg-secondary-3 rounded mb-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row align-items-center" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-black font-16 font-weight-bold"
                            },
                            [_vm._v(" Estudiante seleccionado ")]
                          )
                        ]
                      ),
                      _c("div", { staticClass: "row mt-2" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v("Número de Sie:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedStudent.studentId) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v("Nombre:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.selectedStudent.fullName) + " "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v("Edad:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.selectedStudent.age) + " "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v("Número de Registro:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedStudent.regNumber) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col d-flex justify-content-end align-items-center"
                          },
                          [
                            !_vm.isReadOnly
                              ? _c(
                                  "action-button",
                                  {
                                    staticClass: "pl-4 pr-4",
                                    attrs: {
                                      i: "fas fa-times-circle",
                                      variant: "outline-danger"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onStudentSelectionDelete()
                                      }
                                    }
                                  },
                                  [_vm._v(" Eliminar ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm.selectedStudent != null && _vm.isCompuActivity
            ? _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c("section-title", {
                    attrs: {
                      "has-line": true,
                      title: "Asistencia de estudiante en COMPU"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "col-12 ml-2 p-0 my-2" },
                    [
                      _c(
                        "span",
                        { staticClass: "font-weight-normal font-16" },
                        [_vm._v(" ¿Estudiante asistió a COMPU? ")]
                      ),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-radio", {
                                    staticClass:
                                      "custom-radio__extended p-0 m-0",
                                    attrs: {
                                      "container-class": "p-0 mt-2",
                                      "custom-error-msg": "Marque sí o no.",
                                      disabled: _vm.isReadOnly,
                                      error: Boolean(errors[0]),
                                      "is-inline": "",
                                      name: "question-1",
                                      options: _vm.questionOptions
                                    },
                                    model: {
                                      value: _vm.model.studentAssistance,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "studentAssistance",
                                          $$v
                                        )
                                      },
                                      expression: "model.studentAssistance"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1602706935
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("training-document", {
                ref: "documents",
                attrs: { "is-read-only": _vm.isReadOnly, items: _vm.documents }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }